function injectQuidgetButtonStyles(): void {
  const quidgetButton = document.querySelector<HTMLElement>(
    "#lom_pdp_quidget_btn",
  );
  if (!quidgetButton?.shadowRoot) return;

  const btn =
    quidgetButton.shadowRoot.querySelector<HTMLElement>("#quidget_btn");
  if (!btn) return;

  // Check if styles already injected
  if (quidgetButton.shadowRoot.querySelector("#quidget-custom-styles")) return;

  const style = document.createElement("style");
  style.id = "quidget-custom-styles";
  style.textContent = `
    #quidget_btn {
      outline: 1px solid var(--color-type, #222);
      border: none;
      color: #fff;
      border-radius: 0;
      font-size: var(--type-size, 0.875rem);
      font-weight: 300;
      letter-spacing: var(--letter-spacing, 0.0975rem);
      padding: var(--margin, clamp(10.5px, 1.25vw, 24px));
      text-transform: uppercase;
      transition: all 0.375s cubic-bezier(0.25, 1, 0.5, 1);
      width: 100%;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: inherit;
      max-height: 40px;
    }

    #quidget_btn p {
      margin: 0;
      font-size: inherit;
      font-weight: inherit;
      letter-spacing: inherit;
      text-transform: inherit;
      text-decoration: none;
      text-decoration-line: none;
    }
  `;

  quidgetButton.shadowRoot.prepend(style);

  // Change button text
  const p = btn.querySelector("p");
  if (p) p.textContent = "Find my fit";
}

function waitForQuidgetButton(): void {
  const quidgetButton = document.querySelector<HTMLElement>(
    "#lom_pdp_quidget_btn",
  );

  if (quidgetButton?.shadowRoot) {
    injectQuidgetButtonStyles();
    return;
  }

  // Observe DOM for the quidget-button to appear and its shadow root to be created
  const observer = new MutationObserver(() => {
    const el = document.querySelector<HTMLElement>("#lom_pdp_quidget_btn");
    if (el?.shadowRoot) {
      injectQuidgetButtonStyles();
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Fallback: retry with intervals since shadow root creation may not trigger MutationObserver
  let attempts = 0;
  const interval = setInterval(() => {
    attempts++;
    const el = document.querySelector<HTMLElement>("#lom_pdp_quidget_btn");
    if (el?.shadowRoot) {
      injectQuidgetButtonStyles();
      observer.disconnect();
      clearInterval(interval);
    } else if (attempts > 50) {
      observer.disconnect();
      clearInterval(interval);
    }
  }, 200);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", waitForQuidgetButton);
} else {
  waitForQuidgetButton();
}
